// import "./components/Banner/Banner.css";
import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar/NavBar";
import  {Banner}  from "./components/1-FirstSection/FirstSection";
import { Banner2 } from "./components/5-Tips/Banner2";
import { TDK } from "./components/2-SecondSection/tdk";
import { Grading } from "./components/4-Grading/Grading";
import { Schedule } from "./components/3-Deliverables/Schedule";
import { Video } from "./components/Video/Video";
import { Footer } from "./components/Footer/Footer";
import { History } from "./components/6-History/History";
// import { Oldprojects } from "./components/Oldprojects/Oldprojects";
import { useEffect } from "react";
import { Banner4 } from "./components/8-PreviousProjects/Banner4";
import { Banner3 } from "./components/7-AvailableProject/AvailableProjects";
import { SuccessStories } from "./components/SuccessStories/SuccessStories";


function App() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, []);
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <TDK />
      <Schedule />
      <Grading />
      <Banner2 />
      {/* <Video /> */}
      <SuccessStories />
      <History />
      {/* <Oldprojects/> */}
      <Banner3  />
      <Banner4 />
      <Footer />
    </div>
  );
}

export default App;
